<div id="agreement_container">

  <!-- Title -->
  <h1 class="agreement-title" [cypress]="'page_title'">
    {{ "AGREEMENT.TITLE" | translate }}
  </h1>

  <!-- Subtitle — 32px below title -->
  <p class="agreement-subtitle">
    {{ "AGREEMENT.SUB_TITLE" | translate }}
  </p>

  <!-- Payment-failed notifications — one per failure status -->
  <div *ngIf="paymentFailed$ | async" class="agreement-payment-notification">
    <ng-container *ngIf="failedPaymentStatus$ | async as failedStatus">
      <nes-message-inline
        *ngIf="failedStatus === PaymentStatus.Failure"
        type="error"
        [heading]="'AGREEMENT.PAYMENT_FAILURE_TITLE' | translate"
        close="false"
      >
        {{ "AGREEMENT.PAYMENT_FAILURE_TEXT" | translate }}
      </nes-message-inline>
      <nes-message-inline
        *ngIf="failedStatus === PaymentStatus.Cancelled"
        type="error"
        [heading]="'AGREEMENT.PAYMENT_CANCELLED_TITLE' | translate"
        close="false"
      >
        {{ "AGREEMENT.PAYMENT_CANCELLED_TEXT" | translate }}
      </nes-message-inline>
      <nes-message-inline
        *ngIf="failedStatus === PaymentStatus.Expired"
        type="error"
        [heading]="'AGREEMENT.PAYMENT_EXPIRED_TITLE' | translate"
        close="false"
      >
        {{ "AGREEMENT.PAYMENT_EXPIRED_TEXT" | translate }}
      </nes-message-inline>
      <nes-message-inline
        *ngIf="failedStatus === PaymentStatus.Unknown"
        type="error"
        [heading]="'AGREEMENT.PAYMENT_UNKNOWN_TITLE' | translate"
        close="false"
      >
        {{ "AGREEMENT.PAYMENT_UNKNOWN_TEXT" | translate }}
      </nes-message-inline>
    </ng-container>
  </div>

  <!-- ===== SECTION: Voorwaarden ===== -->
  <section class="agreement-section agreement-conditions">
    <h2 class="agreement-section-heading">
      {{ "AGREEMENT.CONDITIONS_TITLE" | translate }}
    </h2>

    <!-- Checkbox 1: akkoord met de voorwaarden -->
    <div class="checkbox-group">
      <div class="checkbox-row nes-flex nes-items-start">
        <input
          type="checkbox"
          class="checkbox-input nes-h-6 nes-w-6 nes-mr-5"
          name="authorizedAgreementAndProductConditions"
          [formControl]="getControl('authorizedAgreementAndProductConditions')"
          (click)="onCheckboxClick($event, 'authorizedAgreementAndProductConditions')"
          indeterminate="false"
          borderless="false"
          id="authorizedAgreementAndProductConditions"
        />
        <label for="authorizedAgreementAndProductConditions" class="checkbox-label">
          {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.LABEL" | translate }}
        </label>
      </div>
      @if (getAuthorizedAgreementErrorKey()) {
        <nes-error-message>
          {{ getAuthorizedAgreementErrorKey() }}
        </nes-error-message>
      }
      <!-- Links list — 12px below checkbox -->
      <div class="checkbox-article-row">
        <div class="checkbox-offset"></div>
        <div class="terms">
          <span>
            <a stand-alone (click)="showAgreement(AgreementType.PREVIEW)">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.NSBC" | translate }}
            </a>
          </span>
          <span class="file-size">(pdf, 441 kb)</span>,&nbsp;
          <span>
            <a stand-alone (click)="showAgreement(AgreementType.PRODUCT)">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.PRODUCT" | translate }}
            </a>
          </span>
          <span class="file-size">(pdf, 193 kb)</span>,&nbsp;
          <span>
            <a stand-alone (click)="showAgreement(AgreementType.TRANSPORT)">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.TRANSPORT_AND_LUGGAGE" | translate }}
            </a>
            <span class="file-size">(pdf, 262 kb)</span>,&nbsp;
          </span>
          <span>
            <a stand-alone (click)="showAgreement(AgreementType.BTM)">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.URBAN_REGIONAL_PUBLIC_TRANSPORT" | translate }}
            </a>
            <span class="file-size">(pdf, 181 kb)</span>
          </span>
          <span *ngIf="hasSelectedBikeAsService$ | async">
            {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.CONJUNCTION" | translate }}
            <a stand-alone (click)="showAgreement(AgreementType.BIKE)">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.OV_FIETS" | translate }}
            </a>
          </span>
        </div>
      </div>
    </div>

    <!-- Checkbox 2: controle verstrekte gegevens (moved up from position 3) -->
    <div class="checkbox-group">
      <div class="checkbox-row nes-flex nes-items-start">
        <input
          type="checkbox"
          class="checkbox-input nes-h-6 nes-w-6 nes-mr-5"
          name="authorizedVerifyInfo"
          [formControl]="getControl('authorizedVerifyInfo')"
          (click)="onCheckboxClick($event, 'authorizedVerifyInfo')"
          indeterminate="false"
          borderless="false"
          id="authorizedVerifyInfo"
        />
        <label for="authorizedVerifyInfo" class="checkbox-label">
          {{ "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.LABEL" | translate }}
        </label>
      </div>
      @if (isTouchedAndDirty('authorizedVerifyInfo') && hasError('authorizedVerifyInfo', 'required')) {
        <nes-error-message>
          {{ "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.ERROR_REQUIRED" | translate }}
        </nes-error-message>
      }
      <div class="checkbox-article-row">
        <div class="checkbox-offset"></div>
        <p class="checkbox-article">
          {{ "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.CONTENT" | translate }}
        </p>
      </div>
    </div>
  </section>

  <!-- ===== SECTION: Zakelijk rekeningnummer ===== -->
  <section class="agreement-section agreement-payment">
    <h2 class="agreement-section-heading">
      {{ "AGREEMENT.PAYMENT_INFO_HEADER" | translate }}
    </h2>

    <p class="agreement-body-text">
      {{ "AGREEMENT.PAYMENT_INFO_SUBTEXT" | translate }}
    </p>

    <!-- Blue iDEAL | Wero info box -->
    <div class="ideal-wero-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true" class="ideal-wero-icon">
        <g clip-path="url(#clip0_2735_14706)">
          <path d="M30.5898 0H1.41017C0.631354 0 0 0.631354 0 1.41017V30.5898C0 31.3686 0.631354 32 1.41017 32H30.5898C31.3686 32 32 31.3686 32 30.5898V1.41017C32 0.631354 31.3686 0 30.5898 0Z" fill="#FFF48D"/>
          <path d="M6.12999 2.48071V17.2766C6.12999 17.985 6.7125 18.5642 7.42409 18.5642H16.3071C23.0227 18.5642 25.9331 14.8229 25.9331 9.85915C25.9331 4.89535 23.0217 1.19312 16.306 1.19312H7.42301C6.71141 1.19312 6.12891 1.77237 6.12891 2.48071H6.12999Z" fill="white"/>
          <path d="M12.0752 4.82479V15.7579H16.8557C21.1968 15.7579 23.0789 13.3173 23.0789 9.86669C23.0789 6.41611 21.1957 4.00146 16.8557 4.00146H12.9029C12.444 4.00146 12.0752 4.37462 12.0752 4.82587V4.82479Z" fill="#CC0066"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.58188 17.386H16.3064C21.7344 17.386 24.7294 14.7143 24.7294 9.86544C24.7294 7.07114 23.636 2.37744 16.3064 2.37744H8.58188C7.89632 2.37744 7.33984 2.93066 7.33984 3.61405V16.1505C7.33984 16.8328 7.89632 17.3871 8.58188 17.3871V17.386ZM7.75313 3.61405C7.75313 3.15737 8.12194 2.78964 8.58079 2.78964H16.3053C19.2937 2.78964 24.3139 3.71059 24.3139 9.86544C24.3139 14.4496 21.4676 16.9738 16.3053 16.9738H8.58079C8.12194 16.9738 7.75313 16.6071 7.75313 16.1494V3.61405Z" fill="#232323"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4287 8.27626C14.2833 8.22419 14.1315 8.19816 13.9666 8.19816V8.19165H12.8721V10.8319H13.9796C14.1759 10.8319 14.3462 10.7929 14.4916 10.7278C14.637 10.6562 14.7574 10.5651 14.8528 10.4479C14.9483 10.3308 15.0177 10.1876 15.0676 10.0249C15.1121 9.86216 15.137 9.68643 15.137 9.49118C15.137 9.26989 15.1056 9.08114 15.0481 8.91843C14.9852 8.76223 14.9027 8.62555 14.8018 8.5149C14.6944 8.41077 14.574 8.32616 14.4287 8.27409V8.27626ZM14.1683 10.3123C14.0859 10.3384 14.01 10.3514 13.9275 10.3514V10.3579H13.4275V8.6928H13.8321C13.9709 8.6928 14.0848 8.71233 14.1803 8.75138C14.2757 8.79043 14.3506 8.85552 14.4081 8.92711C14.4656 8.9987 14.509 9.09633 14.535 9.20046C14.5599 9.3046 14.573 9.42826 14.573 9.55843C14.573 9.70813 14.5534 9.82528 14.5165 9.92941C14.4786 10.0335 14.4276 10.1117 14.3712 10.1767C14.3137 10.2418 14.2443 10.2874 14.1683 10.3134V10.3123Z" fill="white"/>
          <path d="M17.4208 8.19941V8.68754H16.0659V9.25378H17.3123V9.70286H16.0659V10.3472H17.4522V10.8353H15.5029V8.19507H17.4208V8.20158V8.19941Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.3197 10.8395L19.3575 8.19922H18.7685L17.7998 10.8395H18.3693L18.5721 10.2537H19.5343L19.7307 10.8395H20.3197ZM19.0668 8.84898L19.39 9.81766H18.7251L19.0603 8.84898H19.0668Z" fill="white"/>
          <path d="M21.2368 8.19824V10.3515H22.4897V10.8396H20.6738V8.19933H21.2368V8.19824Z" fill="white"/>
          <path d="M9.85423 10.8788C10.5398 10.8788 11.0952 10.3235 11.0952 9.63681C11.0952 8.95016 10.5398 8.39478 9.85423 8.39478C9.16867 8.39478 8.61328 8.95016 8.61328 9.63681C8.61328 10.3235 9.16867 10.8788 9.85423 10.8788Z" fill="#232323"/>
          <path d="M10.5926 15.8459C9.6315 15.8459 8.86133 15.016 8.86133 13.9964V12.5526C8.86133 12.0427 9.24641 11.624 9.73021 11.624C10.214 11.624 10.5991 12.0362 10.5991 12.5526V15.8459H10.5926Z" fill="#232323"/>
          <path d="M27.9866 21.5865H4.12222C4.0029 21.5865 3.90527 21.4889 3.90527 21.3695C3.90527 21.2502 4.0029 21.1526 4.12222 21.1526H27.9866C28.106 21.1526 28.2036 21.2502 28.2036 21.3695C28.2036 21.4889 28.106 21.5865 27.9866 21.5865Z" fill="#1D1C1C"/>
          <path d="M22.3008 26.9844C22.3008 25.533 23.3335 24.2107 25.1168 24.2107C26.9001 24.2107 27.9404 25.5341 27.9404 26.9844C27.9404 28.4347 26.9077 29.7581 25.1168 29.7581C23.3335 29.7581 22.3008 28.4347 22.3008 26.9844ZM26.3729 26.9844C26.3729 26.2847 25.9119 25.6393 25.1168 25.6393C24.3217 25.6393 23.8606 26.2858 23.8606 26.9844C23.8606 27.683 24.3293 28.3306 25.1168 28.3306C25.9043 28.3306 26.3729 27.684 26.3729 26.9844Z" fill="#1D1C1C"/>
          <path d="M21.2045 28.0145C21.7989 27.6761 22.1558 27.0296 22.1558 26.3158C22.1558 25.256 21.39 24.3535 20.2011 24.3535H17.7051V29.6156H19.2508V28.2705H19.5405L20.4245 29.6156H22.2447L21.2045 28.0145ZM19.8898 27.06H19.2508V25.5717H19.8973C20.3139 25.5717 20.5807 25.9101 20.5807 26.3158C20.5807 26.7215 20.3052 27.06 19.8898 27.06Z" fill="#1D1C1C"/>
          <path d="M10.65 24.3484L9.7225 27.4844L8.81783 24.3484H7.58664L6.67437 27.4844L5.7545 24.3484H4.12305L5.99206 29.6007H7.33498L8.20278 26.7413L9.06298 29.6007H10.4124L12.2814 24.3484H10.65Z" fill="#1D1C1C"/>
          <path d="M14.6197 28.3172H14.6154C14.0372 28.3172 13.6315 27.968 13.4579 27.5059H17.3858C17.4173 27.3323 17.4335 27.1544 17.4335 26.9743C17.4335 25.5273 16.4041 24.2071 14.6186 24.2061V25.6314C15.2 25.6325 15.6014 25.9818 15.7739 26.4428H11.8514C11.82 26.6164 11.8037 26.7943 11.8037 26.9743C11.8037 28.4225 12.8342 29.7437 14.6143 29.7437H14.6186V28.3172H14.6197Z" fill="#1D1C1C"/>
          <path d="M14.6155 29.7429C14.6763 29.7429 14.7348 29.7407 14.7945 29.7385C15.1557 29.7201 15.4844 29.6463 15.7773 29.5281C16.0702 29.4088 16.3273 29.246 16.5453 29.0486C16.7633 28.8512 16.9445 28.6201 17.0844 28.3652C17.2113 28.1342 17.3046 27.8825 17.3632 27.6211H15.7263C15.6927 27.6905 15.6536 27.7578 15.6091 27.8196C15.5484 27.9053 15.4768 27.9823 15.3955 28.0485C15.3141 28.1157 15.223 28.1721 15.1232 28.2155C15.0223 28.2589 14.9138 28.2893 14.7956 28.3056C14.7381 28.3132 14.6784 28.3175 14.6166 28.3175C14.2478 28.3175 13.9506 28.1754 13.738 27.953L12.6738 29.0291C13.1468 29.4662 13.803 29.7418 14.6166 29.7418L14.6155 29.7429Z" fill="url(#paint0_linear_2735_14706)"/>
          <path d="M14.616 24.2051C13.1061 24.2051 12.1352 25.1553 11.876 26.3268H13.5074C13.7027 25.9233 14.0867 25.6304 14.616 25.6304C15.038 25.6304 15.3656 25.8127 15.5793 26.0882L16.6532 25.0024C16.1737 24.5164 15.4838 24.2051 14.6171 24.2051H14.616Z" fill="url(#paint1_linear_2735_14706)"/>
        </g>
        <defs>
          <linearGradient id="paint0_linear_2735_14706" x1="16.5648" y1="26.6676" x2="14.123" y2="29.6582" gradientUnits="userSpaceOnUse">
            <stop offset="0.02" stop-color="#1D1C1C" stop-opacity="0"/>
            <stop offset="0.68" stop-color="#1D1C1C"/>
          </linearGradient>
          <linearGradient id="paint1_linear_2735_14706" x1="12.3055" y1="27.302" x2="14.8091" y2="24.8277" gradientUnits="userSpaceOnUse">
            <stop offset="0.02" stop-color="#1D1C1C" stop-opacity="0"/>
            <stop offset="0.68" stop-color="#1D1C1C"/>
          </linearGradient>
          <clipPath id="clip0_2735_14706">
            <rect width="32" height="32" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span class="ideal-wero-text">{{ "AGREEMENT.PAYMENT_INFO_MESSAGE_BAR_PART1" | translate }}<span class="ideal-wero-break"></span>{{ "AGREEMENT.PAYMENT_INFO_MESSAGE_BAR_PART2" | translate }}</span>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
      <section>
        <bca-choose-issuer
          [issuers]="issuers$ | async"
          [selectedIssuerId]="selectedIssuerId$ | async"
          [issuerRequiredError]="getIssuerErrorKey()"
          (selected)="onIssuerSelected($event)"
        >
        </bca-choose-issuer>
      </section>

      <!-- Checkbox 3: SEPA-incasso (moved down from position 2) -->
      <div class="checkbox-group">
        <div class="checkbox-row nes-flex nes-items-start">
          <input
            type="checkbox"
            class="checkbox-input nes-h-6 nes-w-6 nes-mr-5"
            name="authorizedDirectDebit"
            [formControl]="getControl('authorizedDirectDebit')"
            (click)="onCheckboxClick($event, 'authorizedDirectDebit')"
            indeterminate="false"
            borderless="false"
            id="authorizedDirectDebit"
          />
          <label for="authorizedDirectDebit" class="checkbox-label">
            {{ "AGREEMENT.INPUT.AUTHORIZE_DIRECT_DEBIT.LABEL" | translate }}
          </label>
        </div>
        @if (getDirectDebitErrorKey()) {
          <nes-error-message>
            {{ getDirectDebitErrorKey() }}
          </nes-error-message>
        }
        <div class="checkbox-article-row">
          <div class="checkbox-offset"></div>
          <p class="checkbox-article">
            {{ "AGREEMENT.INPUT.AUTHORIZE_DIRECT_DEBIT.CONTENT" | translate }}
          </p>
        </div>
      </div>

      <!-- Footer: separator + submit -->
      <div class="agreement-footer">
        <hr class="agreement-separator" />
        <div
          *ngIf="startPaymentLoading$ | async; else actionBar"
          class="mt-1 basicLoader"
        ></div>
        <ng-template #actionBar>
          <div class="agreement-button-group">
            <nes-button
              icon-trailing="true"
              type="submit"
              [cypress]="'next_page'"
              variant="brand"
              nes-id="submit"
              (nesOnClick)="formSubmit()"
              class="agreement-submit-btn"
            >
              {{ "AGREEMENT.BUTTON.CONFIRM_DESKTOP" | translate }}
            </nes-button>
          </div>
        </ng-template>
      </div>
    </form>
  </section>
</div>
